import { gql } from "@outschool/ui-apollo";

const ContentfulTutoringPopularSearchesQuery = gql`
  query ContentfulPopularSearches($locale: String, $preview: Boolean) {
    contentfulTutoringPageCollection(
      limit: 1
      skip: 0
      preview: $preview
      locale: $locale
    ) {
      items {
        popularSearchLinksCollection {
          items {
            text
            path
            pathB
          }
        }
      }
    }
  }
`;

export default ContentfulTutoringPopularSearchesQuery;
